import React, {Component} from "react";
import {Modal} from "react-bootstrap";
import {Scrollbars} from "react-custom-scrollbars-2";
import {connect} from "react-redux";
import {PlaceTableOrder} from "../../../redux/actions/Cart.Action";
import CartHeader from "../../Components/Cart/CartHeader";
import CurrentCartData from "../../Components/Cart/CurrentCartData";
import DiscountTotal from "../../Components/Cart/DiscountTotal";
import Fonepay from "../../POS/Components/Payment/Fonepay";

class WaiterCart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      QRModal: false,
      payment: false,
      disabledQRbtn: false,
    };
  }
  PlaceOrder = () => {
    if (this.props.CurrentCart.length !== 0) {
      this.props.PlaceTableOrder();
    }
  };
  handleCloseModal() {
    this.setState({ QRModal: false, payment: false, disabledQRbtn: false });
  }
  RequestQR = () => {
    this.setState({ QRModal: true, disabledQRbtn: true });
  };
  paymentDone = () => {
    this.setState({ payment: true, disabledQRbtn: false });
  };
  render() {
    const CurrentCart = this.props.CurrentCart;
    return (
      <React.Fragment>
        <CartHeader />

        <div className="card">
          <div className="card-body">
            <Scrollbars
              style={{
                height: !this.props.LockScreen
                  ? "calc(100vh - 55ex)"
                  : "calc(100vh - 45ex)",
              }}
            >
              <CurrentCartData />
            </Scrollbars>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <DiscountTotal />
          </div>

          {!this.props.LockScreen ? (
            <button
              className="btn btn-info btn-lg h-20 w-100"
              disabled={CurrentCart.order ? false : true}
              onClick={() => this.PlaceOrder()}
            >
              Send to Kitchen
            </button>
          ) : (
            <button
              className="btn btn-danger btn-lg h-20 w-100"
              onClick={() => this.RequestQR()}
              disabled={this.state.disabledQRbtn}
            >
              Request QR
            </button>
          )}
        </div>

        <Modal show={this.state.QRModal} className="modal-center">
          <Modal.Dialog>
            <Modal.Header>
              <h5 className="modal-title">Fonepay</h5>
              <button
                type="button"
                className="btn"
                onClick={() => this.handleCloseModal()}
              >
                <span>×</span>
              </button>
            </Modal.Header>
            <Modal.Body>
              <Fonepay
                autoCheckout={true}
                fallBack={this.paymentDone}
                total={this.props.CurrentCart.total}
                order_id={
                  this.props.CurrentCart ? this.props.CurrentCart.order_id : ""
                }
              />
            </Modal.Body>
          </Modal.Dialog>
        </Modal>
      </React.Fragment>
    );
  }
}

export default connect(
  (state) => ({
    CurrentCart: state.Cart.CurrentCart,
    LockScreen: state.Auth.lockScreen,
  }),
  {
    PlaceTableOrder,
  }
)(WaiterCart);
